import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceQuery {
    lookupService = new APIServiceLookUp();

    async getAllQuery(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}query/getAllQuery`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateQuery(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}query/updateQuery`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async deleteQuery(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}query/deleteQuery`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}